import { CustomProductType } from "types"

export const checkThatBMCustomProductIsBeerKombuchaOrCider = (
    productType: CustomProductType
): boolean =>
    productType === CustomProductType.Beer ||
    productType === CustomProductType.Cider ||
    productType === CustomProductType.Kombucha
